import { Empresa } from './../configuracion/configuracion.entity';
import { ServicesSunsetService } from './../services-sunset.service';
import { Router } from '@angular/router';
import { Component, OnInit, HostListener } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  mostrar: boolean;
  logo: boolean;
  token: string;
  empresa: Empresa;
  activo: number;
  activar: boolean = false;

  constructor(private route: Router, private _servicios: ServicesSunsetService) {

      this.activo =0;

   }

  ngOnInit() {

    console.log('Bienvenido a Sunset Manager Inventarios');
    this.activo = 0;
    this.token = sessionStorage.getItem('token');
    this.logo = false;
    this.mostrar = false;
    sessionStorage.setItem('fdesde', new Date().toISOString().slice(0, 10));
    sessionStorage.setItem('fhasta', new Date().toISOString().slice(0, 10));
    this.consultarEmpresa();
    this.onResize(0);
    if (this.token.trim() === '') {

      this.route.navigate(['/login']);

    }



  }

  verMenu($event) {

    this.activo = 1;
    this.activar = false;
    this.mostrar = $event;

 }

 click_burguer() {

  this.activo = 1;
  this.activar = !this.activar;
  this.mostrar =  !this.mostrar;
  
}



  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth <= 820) {

      this.logo = true;

    } else {

      this.logo = false;

    }

  }

 
  consultarEmpresa() {

      // this._servicios.MostrarEmpresa().subscribe (

        // (data: Empresa) => {
           this.empresa = JSON.parse(sessionStorage.getItem('empresa')); //data[0];
          // sessionStorage.setItem('empresa', JSON.stringify(this.empresa));

        // });

   }

}
